import React from 'react';
import FullPageError from './FullPageError';

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (!hasError) return children;

    return <FullPageError />;
  }
}

export default ErrorBoundary;
